<template>
  <Header
    :HeaderTitle="'Event'"
    :ShowBack="true"
    :ShowLogoutButton="true"
    v-on:back="back"
  ></Header>

  <!-- Content -->
  <main class="content-wrap event-screen">
    <!-- Event -->
    <div class="event event--overview">
      <div class="event__img">
        <img
          v-if="
            event.ImageID != undefined &&
            event.ImageID != null &&
            event.ImageID.trim() !== ''
          "
          :src="eventUrl + '/downloadhandler.ashx?fid=' + event.ImageID"
          alt="Event"
        />
        <img v-else src="../assets/images/event/img-event.png" alt="Event" />
      </div>

      <div class="event__info">
        <div class="event__name">{{ event.EventName }}</div>
        <div class="event__date">
          {{ formatDateTime(event.DtStart) + " - " + formatDateTime(event.DtEnd) }}
        </div>
        <div class="event__location">{{ event.Location }}</div>
      </div>
    </div>

    <!-- Scan button -->
    <section class="event-scan-section">
      <div class="event-section__title">Event scan</div>
      <ScanButton :EventId="this.event.EventID" :Scanning="'Event'"></ScanButton>
    </section>

    <!-- Attendees section -->
    <section class="event-attendees-section">
      <!-- Attendees header -->
      <div class="clearfix">
        <div class="float-start event-section__title">Event attendees</div>
        <button
          @click="viewAttendees(this.event.EventID)"
          class="float-end event-section__more"
          type="button"
        >
          View all
          <img
            src="../assets/images/event/icon-view-more.svg"
            alt="View all"
            class="ms-1"
          />
        </button>
      </div>

      <!-- Attendees cards -->
      <div class="row overview-stats">
        <!-- Registered card -->
        <EventStats
          :EventStats="eventStats"
          :IsRegistered="true"
          v-on:showRegisteredAttendees="showRegisteredAttendees"
        ></EventStats>

        <!-- Checked-in card -->
        <EventStats
          :EventStats="eventStats"
          :IsRegistered="false"
          v-on:showCheckedInAttendees="showCheckedInAttendees"
        ></EventStats>
      </div>
    </section>

    <!-- Program section -->
    <Program
      v-if="event.programs?.length"
      :EventId="this.event.EventID"
      :Event="event"
    ></Program>
    <p v-if="programsError" role="alert">{{ programsError }}</p>
  </main>
</template>

<script>
import EventStats from "../components/EventStatsComponent.vue";
import ScanButton from "../components/ScanButtonComponent.vue";
import Header from "../components/HeaderComponent.vue";
import Program from "../components/ProgramComponent.vue";

export default {
  components: { EventStats, ScanButton, Header, Program },
  name: "EventView",
  data: () => ({
    eventStats: {},
    eventUrl: process.env.VUE_APP_EVENT_API,
    programsError: "",
  }),
  methods: {
    formatDateTime(date) {
      return new Intl.DateTimeFormat("de-DE", {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric"
      }).format(new Date(date));
    },
    loadEventStats() {
      fetch(
        process.env.VUE_APP_ROOT_API +
          "/v1/DataAPI/GetEventStats/json?" +
          new URLSearchParams({
            AuthToken: this.$store.getters.getAuthToken.token,
            EventID: this.event.EventID,
          }),
        {
          method: "POST",
        }
      )
        .then((resp) => resp.json())
        .then((response) => {
          if (response.serviceStatus === "OK") {
            this.eventStats = response.data;
          }
        })
        .catch((error) => {
          console.error("Error: ", error);
        });
    },
    async loadPrograms() {
      const eventId = this.event?.EventID;
      const token = this.$store.getters.getAuthToken?.token;
      if (!eventId || !token) return;

      try {
        const api = process.env.VUE_APP_ROOT_API.replace(/\/rest$/, "");
        const response = await fetch(`${api}/v1/events/${encodeURIComponent(eventId)}/programs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const programs = (await response.json()).map((program) => ({
          EventProgramID: program.eventProgramId,
          ProgramName: program.name,
          DtStart: program.dtStart,
          DtEnd: program.dtEnd,
          ProgramLocation: program.location,
        }));
        if (this.event?.EventID !== eventId) return;
        this.$store.commit("setPrograms", { programs });
        this.$store.commit("setEvent", { event: { ...this.event, programs } });
        this.programsError = "";
      } catch (error) {
        this.programsError = "Sessions could not be loaded. Try opening the event again.";
        console.error("Error loading sessions:", error);
      }
    },
    back() {
      this.$router.back();
    },
    viewAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 0,
      });

      this.$router.push("/attendees/");
    },
    showRegisteredAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 2,
      });

      this.$router.push("/attendees/");
    },
    showCheckedInAttendees() {
      this.$store.commit("setAttendeeFilter", {
        filter: 3,
      });

      this.$router.push("/attendees/");
    },
  },
  computed: {
    event() {
      return this.$store.getters.getEvent;
    },
  },
  beforeMount() {
    this.loadEventStats();
    this.loadPrograms();
    this.$store.dispatch("loadCheckInSettings", this.event.EventID).catch(() => {});

    this.$store.commit("setEventName", {
      eventName: this.event.EventName,
    });
  },
};
</script>
